import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NOUS_CONTACTER } from "@shared/constants/route.constants";
import { ClaimsRedirectValues } from "@shared/enums/claims-redirect-values";
import { ClaimsType } from "@shared/enums/claims.type";
import { ClaimsTypeService } from "@shared/services/claims-type.service";
import { Guid } from "guid-typescript";
import { ButtonModule } from "primeng/button";
import { ClaimsButtonComponent } from "./claims-buttons/claims-button.component";

@Component({
  selector: "app-service-offerings-pj",
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, ClaimsButtonComponent],
  templateUrl: "./service-offerings-pj.component.html",
})
export class ServiceOfferingsPjComponent implements OnInit {
  @Input({ required: true }) policyId!: Guid;
  @Input({ required: true }) policyReference!: string;
  @Input({ required: true }) isConfortProduct!: boolean;
  @Input() isGdaAllowed = false;
  @Input() isPolicyActive = false;
  ClaimsRedirectValues = ClaimsRedirectValues;
  ClaimsType = ClaimsType;
  isLoading = false;
  claims: any[] = [];

  constructor(
    private readonly claimTypeService: ClaimsTypeService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.claims = this.claimTypeService.getClaims().filter(claim => claim.claimsType === ClaimsType.SFPJ);
  }

  redirectToContactUs() {
    const policyId = this.policyId;
    this.router.navigate([NOUS_CONTACTER], { queryParams: { policyId } });
  }
}
